import { getLoginInfo } from "../auth/getLoginInfo";
import { createAxios, createAxiosWithToken } from "./createAxios";

export async function GetAllAdmin(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/RechargeHistory/GetAllAdmin?PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm + "&FromDate=" + param.FromDate + "&ToDate="
            + param.ToDate
        )

}

export async function GetAllByUserAdmin(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/RechargeHistory/GetAllByUserAdmin?UserId=" + param.UserId + "&PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm)

}

export async function GetAllByUser(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/RechargeHistory/GetAllByUser?PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm)

}

export async function GetRechargePlanInfo(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/RechargeHistory/GetRechargePlanInfo?Count=" + param)

}

export async function InitRecharge(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/RechargeHistory/InitRecharge?Count=" + param)
}

export async function AfterRecharge(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/RechargeHistory/AfterRecharge?rechargeID=" + param.rechargeID + "&paymentId=" + param.paymentId + "&signature=" + param.signature)

}

export async function FailedRecharge(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/RechargeHistory/FailedRecharge?rechargeID=" + param.rechargeID + "&paymentId=" + param.paymentId + "&note=" + param.note)

}

export async function GetRechargePlanInfoSms(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/RechargeHistory/GetRechargePlanInfoSms?Count=" + param)

}

export async function InitRechargeSms(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/RechargeHistory/InitRechargeSms?Count=" + param)
}

export async function AfterRechargeSms(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/RechargeHistory/AfterRechargeSms?rechargeID=" + param.rechargeID + "&paymentId=" + param.paymentId + "&signature=" + param.signature)

}

export async function FailedRechargeSms(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/RechargeHistory/FailedRechargeSms?rechargeID=" + param.rechargeID + "&paymentId=" + param.paymentId + "&note=" + param.note)

}